import {
  Checkbox,
  CheckboxProps,
  Input,
  InputNumberProps,
  InputProps,
  Radio,
  RadioProps,
  Select,
  SelectProps,
  Switch,
  SwitchProps,
} from "antd";
import "./EMatInput.scss";
import EMAT_INPUT_TYPES from "../../../constants/EMatInputTypes";

type EMatInputProps = {
  eMatType: string;
};

const EMatInput = (
  props: InputProps &
    SelectProps &
    EMatInputProps &
    SwitchProps &
    CheckboxProps &
    InputNumberProps &
    RadioProps
) => {
  const { eMatType, className, ...rest } = props;
  let classes = "emat-input ";
  let element = null;

  if (className) classes = classes + className;

  switch (eMatType) {
    case EMAT_INPUT_TYPES.TEXT:
      element = <Input className={classes} {...rest} type="text" />;
      break;
    case EMAT_INPUT_TYPES.PASSWORD:
      element = <Input.Password className={classes} {...rest} type="password" />;
      break;
    case EMAT_INPUT_TYPES.SELECT:
      element = <Select className={classes} {...rest} />;
      break;
    case EMAT_INPUT_TYPES.SWITCH:
      element = <Switch className={classes} {...rest} />;
      break;
    case EMAT_INPUT_TYPES.CHECKBOX:
      element = <Checkbox className={classes} {...rest} />;
      break;
    case EMAT_INPUT_TYPES.NUMBER:
      element = (
        <Input
          onKeyDown={(e) => e.key === "e" && e.preventDefault()}
          type={EMAT_INPUT_TYPES.NUMBER}
          className={classes}
          {...rest}
          lang="en"
        />
      );
      break;
    case EMAT_INPUT_TYPES.RADIO:
      element = <Radio className={classes} {...rest} />;
      break;
    default:
      element = <Input className={classes} {...rest} />;
  }
  return element;
};

export default EMatInput;
